// 错误
export const HOME_FILE = 'HOME_FILE';
// 更新
export const HOME_UPDATE = 'HOME_UPDATE';
